<template>
  <v-container>
    <v-toolbar class="elevation-1" color="white">
      <v-toolbar-title>Пользователи</v-toolbar-title>

      <v-spacer />

      <v-btn
          color="primary"
          dark
          fab
          small
          @click.stop="createItem"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <UserEditor v-model="dialog"
                  :user="editedItem"
                  @on-save="onSave"
      />
    </v-toolbar>

    <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="5"
        class="elevation-1"
        no-results-text="Нет данных"
        no-data-text="Нет данных"
        :footer-props="footerProps"
        @click:row="editItem"
    >
      <template v-slot:item.created_at="{ item }">
        <p class="min-width-145">
          {{ moment(item.created_at).format('YYYY-MM-DD, HH:mm') }}
        </p>
      </template>
      <template v-slot:item.active="{ item }">
        {{ item.active ? 'Работает' : 'Уволен' }}
      </template>
      <template v-slot:item.role="{ item }">
        {{ item.role === 'ADMIN' ? 'Администратор' : 'Пользователь' }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from 'moment';
import UserEditor from "@/modals/UserEditor";

export default {
  name: 'Login',
  components: {
    UserEditor,
  },
  data() {
    return {
      moment: moment,
      footerProps: {
        'items-per-page-options': [10, 20, 30, 50],
        'items-per-page-text': 'Элементов на одной странице:',
        'show-current-page': true,
      },
      headers: [
        {
          text: 'Имя',
          align: 'start',
          sortable: false,
          value: 'firstname',
        },
        { text: 'Фамилия', value: 'lastname' },
        { text: 'Отчество', value: 'middlename' },
        { text: 'E-mail', value: 'email' },
        { text: 'Роль', value: 'role' },
        { text: 'Активность', value: 'active' },
        { text: 'Специальность', value: 'specialization' },
        { text: 'Создан', value: 'created_at' },
      ],
      users: [],
      deleteDialog: false,
      loading: true,
      dialog: false,
      deletedItem: {},
      editedItem: {},
      total: 0,
      pagination: {
        rowsPerPage: 20,
        page: 1,
        sortBy: 'fullname'
      },
      rowsPerPageItems: [20],
    }
  },
  watch: {
    pagination: {
      handler () {
        this.refresh()
      },
      deep: true
    },
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh () {
      this.loading = true
      this.$store.dispatch('users/getList', this.pagination)
      .then(({ data, total }) => {
        this.loading = false
        this.users = data
        this.total = parseInt(total, 10)
      })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.deletedItem = Object.assign({}, item)
      this.deleteDialog = true
    },

    async deleteOnModal() {
      this.loading = true
      await this.$store.dispatch('users/delete', this.deletedItem)
      this.refresh()
      this.deleteDialog = false
      this.loading = false
    },

    createItem () {
      this.editedItem = {}
      this.dialog = true
    },

    onSave () {
      this.refresh()
    },

    toggleSorting () {
      this.pagination.descending = !this.pagination.descending
    }
  },
}
</script>

<style scoped>

</style>
